<template>
  <div class="content stack stack--huge">
    <FlexiHealthCheckCard
      key="flexi-health-check-card"
      :apiURL="flexi.url"
      @status-change="checkFlexi"
    />
    <FlexiCheckLoginCard
      key="flexi-check-login-card"
      :apiURL="flexi.url"
      @status-change="authenticateFlexi"
    />
    <FlexiCompaniesListCard
      v-if="(flexi.url && flexi.username && flexi.password)"
      key="flexi-companies-list-card"
      :apiURL="flexi.url"
      :username="flexi.username"
      :password="flexi.password"
      @change="updateFlexiCompany"
    />
    <div class="flex flex--horizontal flex--align-center horizontal-stack horizontal-stack--huge">
      <FlexiTokenSetupCard
        v-if="flexi.company"
        key="flexi-token-setup-card"
        :apiURL="flexi.url"
        :username="flexi.username"
        :password="flexi.password"
        :company="flexi.company"
      />
      <FlexiButtonsSetupCard
        v-if="flexi.company"
        key="flexi-buttons-setup-card"
        :apiURL="flexi.url"
        :username="flexi.username"
        :password="flexi.password"
        :company="flexi.company"
        :buttons="flexi.buttons"
      />
    </div>
  </div>
</template>

<script>
import FlexiHealthCheckCard from '@/components/FlexiHealthCheckCard';
import FlexiCheckLoginCard from '@/components/FlexiCheckLoginCard';
import FlexiCompaniesListCard from '@/components/FlexiCompaniesListCard';
import FlexiButtonsSetupCard from '@/components/FlexiButtonsSetupCard';
import FlexiTokenSetupCard from '@/components/FlexiTokenSetupCard';

import Flexi from '@/mixins/Flexi';

import Buttons from '@/config/Buttons';

export default {
  name: 'Setup',
  components: {
    FlexiHealthCheckCard,
    FlexiCheckLoginCard,
    FlexiCompaniesListCard,
    FlexiButtonsSetupCard,
    FlexiTokenSetupCard,
  },
  mixins: [
    Flexi,
  ],
  data() {
    return {
      flexi: {
        url: null,
        username: null,
        password: null,
        company: '',
        buttons: Buttons,
      },
    };
  },
  methods: {
    checkFlexi(payload) {
      if (payload.status === 'flexi-available') {
        this.flexi.url = payload.data.url;
      } else {
        this.flexi.url = null;
      }
    },
    authenticateFlexi(payload) {
      if (payload.status === 'logged-in') {
        this.flexi.username = payload.data.username;
        this.flexi.password = payload.data.password;
      } else {
        this.flexi.username = null;
        this.flexi.password = null;
      }
    },
    updateFlexiCompany(payload) {
      this.flexi.company = payload;
    },
  },
};
</script>
